import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { WorkingtimeCsvPreviewItem } from '../types/workingtime/WorkingtimeCsvPreviewItem';

export const WORKINGTIME_HEADER = [
  {
    label: '社員コード',
    sortable: true,
    sortKey: 'employee_code',
    width: '150px',
  },
  { label: '氏名', sortable: false, sortKey: '', width: '150px' },
  { label: '対象期間', sortable: true, sortKey: 'date', width: '150px' },
  { label: '勤務時間', sortable: false, sortKey: '', width: '120px' },
  { label: '稼働時間', sortable: false, sortKey: '', width: '120px' },
  { label: '非稼働時間', sortable: false, sortKey: '', width: '120px' },
  { label: '稼働率', sortable: false, sortKey: '', width: '100px' },
  { label: '平日稼働', sortable: false, sortKey: '', width: '100px' },
  { label: '平日残業', sortable: false, sortKey: '', width: '100px' },
  { label: '週末残業', sortable: false, sortKey: '', width: '100px' },
];

export const WORKINGTIME_MODAL_FIELDS: FieldDescriptor<WorkingtimeCsvPreviewItem>[] =
  [
    { label: '対象期間', key: 'date', type: 'date' },
    { label: '氏名', key: 'employeeName', type: 'text' },
  ];
